<template>
  <generic-modal :title="$t('work order')" ref="generic_modal">
    <div>
      <div class="form">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("name") }}</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="meta.name"
                  :placeholder="$t('work order name')"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("delivery date") }}</label>
              <generic-calendar
                type="date"
                display_mode="dialog"
                ref="delivery_date_calendar"
                @selected="delivery_date_changed"
              />
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="buttons">
              <div
                class="button is-rounded"
                v-bind:class="{ 'is-primary': selected == pend.source }"
                @click="
                  summary = pend.summary;
                  selected = pend.source;
                "
                v-for="(pend, pidx) in pending"
              >
                <span
                  >{{ pend.source }} [{{ pend.total_orders }}
                  {{ $t("orders") }}]</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <ul>
              <li v-for="(sum, sidx) in summary" :key="sidx">
                <span>{{ sum.quantity }} x {{ sum.product }}</span>
                <p class="pl-5">
                  <div v-for="(ordr, oidx) in sum.orders" :key="oidx">
                    <span v-if="ordr.customization">- {{ ordr.customization }} ({{ parseInt(ordr.quantity) }})</span>   
                  </div>
                </p>
              </li>
            </ul>
            <!-- <pre>{{ summary }}</pre> -->
          </div>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  post,
  get,
  generate_error_message_text,
  format_date,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";

export default {
  name: "WorkOrderModal",
  components: { GenericModal, GenericCalendar },
  props: {},
  data() {
    return {
      meta: {},
      summary: [],
      selected: "",
      pending: [],
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name || !v.meta.settings.delivery_date || !v.selected;
    },
  },
  methods: {
    format_currency,
    format_date,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.get_pending();
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let work_order = { ...v.meta };
      let all_orders = v.summary
        .map((s) => {
          return s.orders.map((o) => {
            return o.order_id;
          });
        })
        .reduce((a, b) => a.concat(b), []);
      work_order.tailoring_orders = [...new Set(all_orders)];
      work_order.source = v.selected;
      put("/work_order", work_order)
        .then(() => {
          v.close_modal();
          v.$emit("success");
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.close_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {
          delivery_date: "",
        },
      };
      v.pending = [];
      v.selected = "";
      v.summary = [];
      v.error = "";
    },
    delivery_date_changed(date) {
      let v = this;
      v.meta.settings.delivery_date = date;
    },
    get_pending() {
      let v = this;
      get("/work_order/pending-tailoring-orders")
        .then((pending) => {
          v.pending = pending.map((p) => {
            p.summary = p.summary.sort((a, b) => {
              if (a.product < b.product) return -1;
              if (a.product > b.product) return 1;
              return 0;
            });
            return p;
          });
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
  },
  mounted() {
    // this.show_modal();
  },
  created() {},
  watch: {},
};
</script>
<style></style>
